/* ============================================================
   BURL — dynamic product page (wired to Shopify {{ product }})
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* gallery */
  var mainImg = $('#mainImg');
  $$('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var src = t.getAttribute('data-src');
      if (!mainImg) return;
      mainImg.style.opacity = '0';
      var pre = new Image();
      pre.onload = function () { mainImg.src = src; mainImg.style.opacity = '1'; };
      pre.src = src;
    });
  });

  /* lightbox */
  var lightbox = $('#lightbox'), lightboxImg = $('#lightboxImg');
  function openLb() { if (!lightbox) return; lightboxImg.src = mainImg.src; lightbox.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeLb() { if (!lightbox) return; lightbox.classList.remove('open'); document.body.style.overflow = ''; }
  var zoomBtn = $('#zoomBtn'); if (zoomBtn) zoomBtn.addEventListener('click', openLb);
  if (mainImg) mainImg.addEventListener('click', openLb);
  var lbClose = $('#lightboxClose'); if (lbClose) lbClose.addEventListener('click', closeLb);
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLb(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });

  /* ---- variants / options ---- */
  var variants = window.__variants || [];
  var prices = window.__prices || {};
  var optionEls = $$('.opt[data-option-index]');
  var selected = optionEls.map(function (el) {
    var active = $('.js-opt.is-active', el);
    return active ? active.getAttribute('data-value') : null;
  });

  function findVariant() {
    if (!variants.length) return null;
    return variants.filter(function (v) {
      return v.options.every(function (val, i) { return selected[i] == null || String(val) === String(selected[i]); });
    })[0] || null;
  }

  var variantIdEl = $('#variantId'), priceNow = $('#priceNow'), addPrice = $('#addPrice'),
      stickyPrice = $('#stickyPrice'), addBtn = $('#addBtn');

  function applyVariant() {
    var v = findVariant();
    if (!v) return;
    if (variantIdEl) variantIdEl.value = v.id;
    var p = prices[v.id] || {};
    if (priceNow && p.label) priceNow.textContent = p.label;
    if (addPrice && p.label) addPrice.textContent = p.label;
    if (stickyPrice && p.label) stickyPrice.textContent = p.label;
    if (addBtn) {
      var avail = p.avail !== false && v.available !== false;
      addBtn.disabled = !avail;
      if (!avail) addBtn.textContent = 'Sold out';
      else if (addPrice) { addBtn.innerHTML = 'Add to cart · <span id="addPrice">' + (p.label || '') + '</span>'; }
    }
  }

  $$('.js-opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.opt');
      var i = parseInt(btn.getAttribute('data-index'), 10);
      if (isNaN(i) && group) i = parseInt(group.getAttribute('data-option-index'), 10);
      if (isNaN(i)) return;
      $$('.js-opt', group).forEach(function (x) { x.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selected[i] = btn.getAttribute('data-value');
      var lab = $('.opt-val', group); if (lab) lab.textContent = btn.getAttribute('data-value');
      applyVariant();
    });
  });

  /* quantity */
  var qty = 1, qtyVal = $('#qtyVal'), qtyInput = $('#qtyInput');
  function setQty(n) { qty = Math.max(1, Math.min(9, n)); if (qtyVal) qtyVal.textContent = qty; if (qtyInput) qtyInput.value = qty; }
  var qm = $('#qtyMinus'), qp = $('#qtyPlus');
  if (qm) qm.addEventListener('click', function () { setQty(qty - 1); });
  if (qp) qp.addEventListener('click', function () { setQty(qty + 1); });

  /* add to cart (AJAX) */
  var cartCount = $('#cartCount');
  var addForm = $('#addForm');
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('#cartCount, .nav__cart-count').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }
  function flash(btn, msg) {
    if (!btn) return; var html = btn.innerHTML; btn.disabled = true; btn.textContent = msg;
    setTimeout(function () { btn.innerHTML = html; btn.disabled = false; }, 1700);
  }
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = findVariant() || variants[0];
      if (!v) { window.location.href = '/cart'; return; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        // 14/10/2026: gửi kèm lựa chọn bề mặt (properties[Surface]) như form Shopify gốc
        body: JSON.stringify((function () {
          var b = { id: v.id, quantity: qty }, props = {};
          $$('input[name^="properties["]:checked, input[type="hidden"][name^="properties["]', addForm).forEach(function (i) { props[i.name.slice(11, -1)] = i.value; });
          if (Object.keys(props).length) b.properties = props;
          return b;
        })())
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (res.ok) { if (window.showCartPopup) window.showCartPopup(res.d); refreshCart(); flash(addBtn, '✓ Added to cart'); }
          else { flash(addBtn, res.d.description || 'Unavailable'); }
        }).catch(function () { addForm.submit(); });
    });
  }
  var stickyAdd = $('#stickyAdd');
  if (stickyAdd) stickyAdd.addEventListener('click', function () {
    if (addForm) addForm.requestSubmit ? addForm.requestSubmit() : addForm.dispatchEvent(new Event('submit', { cancelable: true }));
  });

  /* wishlist */
  var wishBtn = $('#wishBtn');
  if (wishBtn) wishBtn.addEventListener('click', function (e) {
    e.preventDefault();
    this.classList.toggle('is-saved');
    this.textContent = this.classList.contains('is-saved') ? '♥ Saved to wishlist' : '♡ Save to wishlist';
  });

  /* sticky add bar */
  var stickybar = $('#stickybar');
  if (stickybar && addBtn) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting && en.boundingClientRect.top < 0) stickybar.classList.add('show');
        else stickybar.classList.remove('show');
      });
    }, { threshold: 0 }).observe(addBtn);
  }

  /* faq single-open */
  var faqs = $$('.faq details');
  faqs.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; }); }); });

  /* long description: show "read more" only when it actually overflows the clamp */
  var descBody = $('#descBody'), descToggle = $('#descToggle');
  if (descBody && descToggle) {
    if (descBody.scrollHeight > descBody.clientHeight + 8) {
      descToggle.hidden = false;
      descToggle.addEventListener('click', function () {
        var open = descBody.classList.toggle('open');
        descToggle.textContent = open ? 'Show less' : 'Read full description';
      });
    }
  }

  applyVariant();
})();
